import React from 'react';
import { Link } from 'react-router-dom';
import dhanwalleLogo from '../assets/images/Dhanwalle_Logo.png';
import landingBanner from '../assets/images/landing-banner.jpg';
import ApplyNow from '../components/apply-now';
import './FundwalleLanding.css';

const FundwalleLanding = () => {
  return (
    <div className="dwl-landing">
      <section className="dwl-landing-hero">
        <div className="dwl-landing-image-side">
          <img
            src={landingBanner}
            className="dwl-landing-hero-img"
            alt=""
            aria-hidden="true"
          />
          <div className="dwl-landing-image-fade" aria-hidden="true" />
          <Link to="/" className="dwl-landing-image-logo">
            <img src={dhanwalleLogo} alt="Dhanwalle" />
          </Link>
        </div>

        <div className="dwl-landing-form-wrap" id="dwl-landing-form">
          <div className="dwl-landing-form-card dwl-landing-form-card--embed">
            <h1 className="dwl-landing-card-title">Apply for Loan</h1>

            <div className="dwl-landing-form-scroll">
              <ApplyNow embedded="landing" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FundwalleLanding;
